export function makeRequest(url: string, options: HttpRequestOptions) {

    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        //xhr.setRequestHeader('Access-Control-Allow-Origin', 'http://localhost:51712');
        xhr.open(options.requestMethod, url);
        xhr.onload = function () {

            if (xhr.status >= 200 && xhr.status < 400) {
                //Handling IE11 bug where it ignores responseType='json'
                if (typeof xhr.response === 'string' && options.responseType && options.responseType === 'json') {
                    resolve(JSON.parse(xhr.response));
                } else {
                    resolve(xhr.response);
                }
            } else {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        }
        xhr.onerror = function () {
            reject({
                status: xhr.status,
                statusText: xhr.statusText
            });
        }
        if (options.responseType) {
            xhr.responseType = options.responseType as XMLHttpRequestResponseType;
        }
        if (options.headers) {
            Object.keys(options.headers).forEach((key) => {
                xhr.setRequestHeader(key, options.headers[key]);
            });
        }

        if (options.params) {
            xhr.send(options.params);
        } else {
            xhr.send(null);
        }
    });
}

export interface HttpRequestOptions {
    requestMethod: string;
    responseType?: string,
    headers?: object,
    params?: string
}